module.exports = __webpack_public_path__ + "img/star-icon.34daad10.svg";